import React, { useState } from "react";
import PostHooks from "../../Api/PostHooks";
import { useForm } from "react-hook-form";
import AlertComponent from "../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const CreateBankAcount = ({ user, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [loading, response, request] = PostHooks();

  const createAcc = async (e) => {
    try {
      let formData = {
        account_name: e.account_name,
        account_balance: e.account_balance,
        account_description: e.account_description,
      };

      let props = {
        url: "account",
        body: formData,
      };
      const accReq = await response(props);

      console.log("/account", accReq);

      if (accReq && accReq.status === 200 && accReq.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Loan application successful!",
        });
        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else if (
        accReq &&
        (accReq.status === 200 || accReq.status !== 200) &&
        accReq.data.StatusCode !== 0
      ) {
        const errorMessage =
          accReq?.data?.StatusMessage ??
          accReq?.data?.message ??
          accReq.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("create bank acc err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(createAcc)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.account_name}
      >
        <InputLabel htmlFor="account_name">Account Name</InputLabel>
        <OutlinedInput
          fullWidth
          id="account_name"
          type="text"
          label={`Account Name`}
          {...register("account_name")}
        />
        {errors.account_name && (
          <FormHelperText>Enter an account name!</FormHelperText>
        )}
      </FormControl>

      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.account_balance}
      >
        <InputLabel htmlFor="account_balance">Account Balance</InputLabel>
        <OutlinedInput
          fullWidth
          id="account_balance"
          type="number"
          label={`Account Balance`}
          {...register("account_balance")}
          inputProps={{ step: "any" }}
          onWheel={(event) => {
            event.target.blur();
          }}
        />
        {errors.account_balance && (
          <FormHelperText>Enter balance!</FormHelperText>
        )}
      </FormControl>

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" type="reset" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={loading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default CreateBankAcount;
